// extracted by mini-css-extract-plugin
export default {"button":"Button_button__MwZi7","primary":"Button_primary__c6d3j","secondary":"Button_secondary__4ONJ4"};